module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/tasks/consultancy/consultancy.component.css
// module id = ./src/app/Pages/tasks/consultancy/consultancy.component.css
// module chunks = main